import { get } from 'lodash';

function calculateHeadersAndFootersHeight(
  tableSelector = 'div.v-data-table__wrapper',
  defaultHeight = 700
) {
  // Note this function should be run after component is mounted, otherwise elements may not have been rendered, so may have incorrect or missing heights.
  const originalDataTableHeight = get(
    document.querySelector(tableSelector),
    'offsetHeight',
    defaultHeight
  );
  const documentHeight = document.body.offsetHeight;

  // Remove the original height of the table from the height of the body to get the total height the headers, footers, etc take.
  return documentHeight - originalDataTableHeight;
  // Then remove the value returned here from the window height, to fit the table to the window.
  // Need to do this every time the window is resized.
}

export default calculateHeadersAndFootersHeight;
